import React, { useEffect, useState } from "react";

const API_BASE = process.env.REACT_APP_API_URL;

const thStyle = {
  border: "1px solid #ccc",
  padding: "0.5rem",
  textAlign: "center",
};

const tdStyle = {
  border: "1px solid #ccc",
  padding: "0.5rem",
  textAlign: "center",
};

const PashukhadyaTab = ({ fromDate, toDate }) => {
  const [feedData, setFeedData] = useState([]);
  const [loading, setLoading] = useState(false);

  const farmerUsername = localStorage.getItem("farmerUsername") || "F-B-3";

  useEffect(() => {
    const fetchFeedData = async () => {
      setLoading(true);
      try {
        const res = await fetch(`${API_BASE}/getTransactions`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            username: farmerUsername,
            from_date: fromDate,
            to_date: toDate,
            trantype: "CFD", // ✅ API should return CFD-related transactions
            group_by_type: false,
          }),
        });

        if (!res.ok) throw new Error("Failed to fetch");
        const data = await res.json();

        const transactions = data.transactions || [];

        // After filtering CFD transactions
        let filtered = (data.transactions || []).filter((t) =>
          String(t.trantype).toUpperCase().includes("CFD")
        );

        // ✅ Sort by date (choose one)

        // Oldest first (ascending)
        filtered.sort(
          (a, b) => new Date(a.tran_date) - new Date(b.tran_date)
        );
        
        setFeedData(filtered);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchFeedData();
  }, [fromDate, toDate, farmerUsername]);

  return (
    <div
      style={{
        height: "calc(100vh - 120px)",
        overflowY: "auto",
        padding: "1rem",
        fontFamily: "Mukta, sans-serif",
        backgroundColor: "#f9f9f9",
      }}
    >
      <h2 style={{ fontSize: "1.2rem", marginBottom: "1rem" }}>
        🐄 पशुखाद्य खर्च
      </h2>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            fontSize: "0.95rem",
            backgroundColor: "#fff",
          }}
        >
          <thead>
            <tr style={{ backgroundColor: "#f0f8f5" }}>
              <th style={thStyle}>दिनांक</th>
              {/* <th style={thStyle}>तपशील</th> */}
              <th style={thStyle}>नावे रक्कम</th>
              <th style={thStyle}>जमा रक्कम</th>
            </tr>
          </thead>
          <tbody>
            {feedData.map((entry, index) => (
              <tr key={index}>
                <td style={tdStyle}>
                  {new Date(entry.tran_date).toLocaleDateString("en-GB")}
                </td>
                {/* <td style={tdStyle}>{entry.item || "-"}</td> */}
                <td style={tdStyle}>
                  {entry.dramt > 0 ? `₹${Number(entry.dramt).toFixed(2)}` : "-"}
                </td>
                <td style={tdStyle}>
                  {entry.cramt > 0
                    ? `₹${Number(entry.cramt).toFixed(2)}`
                    : "-"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default PashukhadyaTab;
